import { DrawerPanel } from '@dmc/ui';
import { ReactElement } from 'react';
import AssetsAssignConfigurationGroupForm from './components/assets-assign-configuration-group-form/AssetsAssignConfigurationGroupForm';
import useAssetsAssignConfigurationGroupLoadModelData from '@casops/components/layout/model-form/useAssetsAssignConfigurationGroupLoadModelData';
import { ModelName } from '@casops/store/api';
import { useRenderKey } from '@casops/hooks/useRenderKey';
import { useTranslation } from 'react-i18next';

const modelName = ModelName.Asset;

export function AssetsAssignConfigurationGroupPanel(): ReactElement {
  const { t } = useTranslation();

  const title = t(`Model.Assign.Title`, { modelName });

  const { isLoaded, configurationGroups, defaultConfigurationId, selectedAssetIds } =
    useAssetsAssignConfigurationGroupLoadModelData();

  // The renderKey must update whenever the item data changes to ensure the form is remounted and RHK and VDS stay in sync.
  const renderKey = useRenderKey({
    configurationGroupIds: configurationGroups?.map(cg => cg.id),
    defaultConfigurationId,
  });

  return (
    <DrawerPanel isLoaded={isLoaded} header={title}>
      <AssetsAssignConfigurationGroupForm
        key={renderKey}
        configurationGroups={configurationGroups}
        defaultConfigurationId={defaultConfigurationId}
        selectedAssetIds={selectedAssetIds}
      />
    </DrawerPanel>
  );
}

export default AssetsAssignConfigurationGroupPanel;
